"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EbayPagination = exports.EbayItems = exports.EbayItemHeader = exports.EbayItemH = exports.EbayItem = void 0;
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pixelated = require("../utilities/pixelated.api");
var _pixelated2 = require("../utilities/pixelated.functions");
require("./pixelated.ebay.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable */
class EbayItems extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "isJson", str => {
      try {
        JSON.parse(str);
      } catch (e) {
        //Error - JSON is not okay
        return false;
      }
      return true;
    });
    this.gotoPage = this.gotoPage.bind(this);
    this.state = {
      /* 
      // proxyURL: "https://api.codetabs.com/v1/proxy/?quest=",
      // proxyURL: 'https://x3cf4kv0nk.execute-api.us-east-2.amazonaws.com/prod/proxy?url=',
      proxyURL: 'https://corsproxy.io/?',
      baseURL: "https://svcs.ebay.com/services/search/FindingService/v1?",
      urlProps: {
      	"OPERATION-NAME": "findItemsByKeywords",
      	"SERVICE-VERSION": "1.0.0",
      	"SECURITY-APPNAME": "BrianWha-Pixelate-PRD-1fb4458de-1a8431fe",
      	"GLOBAL-ID": "EBAY-US",
      	"RESPONSE-DATA-FORMAT": "JSON",
      	"REST-PAYLOAD": "",
      	"keywords": "sunglasses",
      	"outputSelector": "PictureURLSuperSize",
      	"paginationInput.entriesPerPage": 10,
      	"paginationInput.pageNumber": 1,
      	"sortOrder": "StartTimeNewest",
      	"itemFilter(0).name": "Seller",
      	"itemFilter(0).value": "btw73"
      	// url += "&callback=_cb_findItemsByKeywords";
      },
      filterarray: [{
      	"name":"Seller",
      	"value":"btw73",
      	"paramName":"",
      	"paramValue":""
      }], */
      proxyURL: "",
      baseURL: "",
      urlProps: {},
      filterarray: [{}],
      totalPages: 1,
      items: []
    };
    if (this.props.ebayProps.proxyURL) {
      this.state.proxyURL = this.props.ebayProps.proxyURL;
    }
    if (this.props.ebayProps.baseURL) {
      this.state.baseURL = this.props.ebayProps.baseURL;
    }
    this.state.urlProps = (0, _pixelated2.mergeDeep)(this.state.urlProps, this.props.ebayProps.urlProps);
  }

  // Generates an indexed URL snippet from the array of item filters
  buildURLArray(filterarray) {
    var urlfilter = "";
    // Iterate through each filter in the array
    for (var i = 0; i < filterarray.length; i++) {
      //Index each item filter in filterarray
      var itemfilter = filterarray[i];
      // Iterate through each parameter in each item filter
      for (var index in itemfilter) {
        // Check to see if the paramter has a value (some don't)
        if (itemfilter[index] !== "") {
          if (itemfilter[index] instanceof Array) {
            for (var r = 0; r < itemfilter[index].length; r++) {
              var value = itemfilter[index][r];
              urlfilter += "&itemFilter\(" + i + "\)." + index + "\(" + r + "\)=" + value;
            }
          } else {
            urlfilter += "&itemFilter\(" + i + "\)." + index + "=" + itemfilter[index];
          }
        }
      }
    }
    return urlfilter;
  }
  loadItems(root) {
    var items = root.findItemsByKeywordsResponse[0].searchResult[0].item || [];
    var pages = root.findItemsByKeywordsResponse[0].paginationOutput[0].totalPages;
    this.setState({
      totalPages: pages
    });
    var newItems = [];
    for (var i = 0; i < items.length; ++i) {
      var newItem = {};
      var item = items[i];
      newItem.title = item.title[0];
      // newItem.image = item.galleryURL[0];
      newItem.image = item.pictureURLSuperSize[0];
      newItem.price = (item.sellingStatus[0].currentPrice[0].__value__ * 1).toFixed(2);
      newItem.url = item.viewItemURL[0];
      newItem.location = item.location[0];
      newItem.endTime = item.listingInfo[0].endTime[0];
      newItem.watchCount = item.listingInfo[0].watchCount ? item.listingInfo[0].watchCount[0] * 1 : 0;
      newItem.id = item.itemId[0];
      newItem.key = item.itemId[0];
      newItems.push(newItem);
    }
    this.setState({
      items: newItems
    });
  }
  paintItems(items) {
    var newItems = [];
    for (let i in items) {
      var item = items[i];
      var newItem = /*#__PURE__*/_react.default.createElement(EbayItemH, {
        url: item.url,
        image: item.image,
        title: item.title,
        price: item.price,
        id: item.id,
        key: item.id,
        location: item.location,
        endTime: item.endTime,
        watchCount: item.watchCount
      });
      newItems.push(newItem);
    }
    return newItems;
  }
  gotoPage(pageNum) {
    window.scrollTo({
      top: 0
    });
    // window.scroll({ top: 0, behavior: 'smooth' })let state = { ...this.state };
    let newState = _objectSpread({}, this.state);
    newState.urlProps["paginationInput.pageNumber"] = pageNum;
    this.setState(newState);
    this.componentDidMount();
  }
  componentDidMount() {
    const myURL = this.state.proxyURL + encodeURIComponent((0, _pixelated.generateURL)(this.state.baseURL, this.state.urlProps));
    var myMethod = "GET";
    (0, _pixelated.getXHRData)(myURL, myMethod, btw73 => {
      if (this.isJson(btw73)) {
        this.loadItems(JSON.parse(btw73));
      } else {
        this.loadItems(btw73);
      }
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "section-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayPagination grid12"
    }, /*#__PURE__*/_react.default.createElement(EbayPagination, {
      totalPages: 1 * this.state.totalPages,
      currentPage: 1 * this.state.urlProps["paginationInput.pageNumber"],
      gotoPage: this.gotoPage
    })), /*#__PURE__*/_react.default.createElement("div", {
      id: "EbayItems",
      className: "EbayItems grid12"
    }, this.paintItems(this.state.items)), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayPagination grid12"
    }, /*#__PURE__*/_react.default.createElement(EbayPagination, {
      totalPages: 1 * this.state.totalPages,
      currentPage: 1 * this.state.urlProps["paginationInput.pageNumber"],
      gotoPage: this.gotoPage
    })));
  }
}
exports.EbayItems = EbayItems;
// https://developer.ebay.com/devzone/finding/HowTo/GettingStarted_JS_NV_JSON/GettingStarted_JS_NV_JSON.html
_defineProperty(EbayItems, "propTypes", {
  ebayProps: _propTypes.default.object.isRequired
});
class EbayItem extends _react.Component {
  render() {
    var EbayItemTarget = this.props.url && this.props.url.substring(0, 4).toLowerCase() === "http" ? "_blank" : "_self";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItem column grid4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemHeader"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement(EbayItemHeader, {
      url: this.props.url,
      title: this.props.title
    }) : /*#__PURE__*/_react.default.createElement(EbayItemHeader, {
      title: this.props.title
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemPhoto grid12"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: EbayItemTarget,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.image,
      alt: this.props.title
    })) : /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.image,
      alt: this.props.title
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemDetails grid12"
    }, /*#__PURE__*/_react.default.createElement("div", null, "Location: ", this.props.location), /*#__PURE__*/_react.default.createElement("div", null, "End Time: ", this.props.endTime), /*#__PURE__*/_react.default.createElement("div", null, "Watchers: ", this.props.watchCount)), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemPrice"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: EbayItemTarget
    }, "$", this.props.price) : $this.props.price));
  }
}
exports.EbayItem = EbayItem;
_defineProperty(EbayItem, "propTypes", {
  title: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired,
  price: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired,
  location: _propTypes.default.string.isRequired,
  endTime: _propTypes.default.string.isRequired,
  watchCount: _propTypes.default.number,
  id: _propTypes.default.string.isRequired
});
class EbayItemH extends _react.Component {
  render() {
    var EbayItemTarget = this.props.url && this.props.url.substring(0, 4).toLowerCase() === "http" ? "_blank" : "_self";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemH column grid6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemPhoto grid6"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: EbayItemTarget,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.image,
      alt: this.props.title
    })) : /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.image,
      alt: this.props.title
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemHeader"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement(EbayItemHeader, {
      url: this.props.url,
      title: this.props.title
    }) : /*#__PURE__*/_react.default.createElement(EbayItemHeader, {
      title: this.props.title
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemDetails grid12"
    }, /*#__PURE__*/_react.default.createElement("div", null, "Location: ", this.props.location), /*#__PURE__*/_react.default.createElement("div", null, "End Time: ", new Date(this.props.endTime).toLocaleTimeString('en-us', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })), /*#__PURE__*/_react.default.createElement("div", null, "Watchers: ", this.props.watchCount)), /*#__PURE__*/_react.default.createElement("div", {
      className: "EbayItemPrice"
    }, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: EbayItemTarget
    }, "$", this.props.price) : $this.props.price)));
  }
}
exports.EbayItemH = EbayItemH;
_defineProperty(EbayItemH, "propTypes", {
  title: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired,
  price: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired,
  location: _propTypes.default.string.isRequired,
  endTime: _propTypes.default.string.isRequired,
  watchCount: _propTypes.default.number,
  id: _propTypes.default.string.isRequired
});
class EbayItemHeader extends _react.Component {
  render() {
    var EbayItemTarget = this.props.url && this.props.url.substring(0, 4).toLowerCase() === "http" ? "_blank" : "_self";
    return /*#__PURE__*/_react.default.createElement("span", null, this.props.url ? /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.url,
      target: EbayItemTarget,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: ""
    }, this.props.title)) : /*#__PURE__*/_react.default.createElement("h2", {
      className: ""
    }, this.props.title));
  }
}
exports.EbayItemHeader = EbayItemHeader;
_defineProperty(EbayItemHeader, "propTypes", {
  title: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
});
class EbayPagination extends _react.Component {
  render() {
    var pageLinks = [];
    for (let i = 1; i <= this.props.totalPages; i++) {
      var key = "page" + i;
      // var pageLink = <div className="EbayPage" key={key} onClick={() => { this.props.gotoPage(i);} }>{i}</div> ;
      var pageLink = i == this.props.currentPage ? /*#__PURE__*/_react.default.createElement("div", {
        className: "EbayPageCurrent",
        key: key
      }, i) : /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "EbayPage",
        key: key,
        onClick: e => {
          e.preventDefault();
          this.props.gotoPage(i);
        }
      }, i);
      pageLinks.push(pageLink);
    }
    return pageLinks;
  }
}
exports.EbayPagination = EbayPagination;
_defineProperty(EbayPagination, "propTypes", {
  totalPages: _propTypes.default.number,
  currentPage: _propTypes.default.number,
  gotoPage: _propTypes.default.func
});